import React from 'react';
import { Section } from './ui/Section';
export function Bonuses() {
  const bonuses = [{
    icon: '⚡',
    title: 'Kit de Arranque Rápido',
    desc: 'Implementa en 60 minutos'
  }, {
    icon: '✅',
    title: 'Checklist Clase Perfecta',
    desc: 'Sistema pre durante y post clase'
  }, {
    icon: '🔥',
    title: 'Guía de Retención',
    desc: 'Detecta abandonos antes'
  }, {
    icon: '💬',
    title: 'Plantillas WhatsApp',
    desc: '+40 mensajes listos'
  }, {
    icon: '📅',
    title: 'Planificador Semanal',
    desc: 'Organiza clases y ventas'
  }, {
    icon: '👑',
    title: 'Primera Impresión',
    desc: 'Proyecta autoridad'
  }];
  return <Section data-id="element-74">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-8 text-brand-title" data-id="element-75">
        🎁 MÁS 6 BONOS GRATIS
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-76">
        {bonuses.map((bonus, i) => <div key={i} className="bg-brand-cardPeach border border-brand-border rounded-2xl p-6 text-center shadow-card hover:shadow-gold-glow transition-all hover:border-brand-borderGlow/60 relative" data-id="element-77">
            <div className="absolute top-3 right-3 bg-brand-title text-white text-xs font-bold px-2 py-1 rounded" data-id="element-78">
              GRATIS
            </div>
            <div className="text-4xl mb-4" data-id="element-79">{bonus.icon}</div>
            <h3 className="font-heading text-lg font-bold text-brand-title mb-2 tracking-wide" data-id="element-80">
              {bonus.title}
            </h3>
            <p className="font-body text-brand-text" data-id="element-81">{bonus.desc}</p>
          </div>)}
      </div>
    </Section>;
}